import { makeStyles, Theme } from "@material-ui/core";

const closeButtonStyles = makeStyles(
  (theme: Theme) => ({
    closeBtn: {
      position: "fixed",
      top: "10px",
      right: "10px",
      // borderRadius: "50%",
      // backgroundColor: "#EFEFEF",
      // padding: "3px",
      // boxShadow: "5px 6px 5px 0px #00000029",
    },
  }),
  { index: 1 }
);

export default closeButtonStyles;
